var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopInning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M7.394 21.211l4.882-9.764A1 1 0 0 0 11.382 10H1.618a1 1 0 0 0-.894 1.447l4.882 9.764a1 1 0 0 0 1.788 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "M7.394.789l4.882 9.764A1 1 0 0 1 11.382 12H1.618a1 1 0 0 1-.894-1.447L5.606.789a1 1 0 0 1 1.788 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopInning);
export default __webpack_public_path__ + "static/media/topInning.9e799d3e64354f33629065c143ad4025.svg";
export { ForwardRef as ReactComponent };